import React, { useState, useEffect } from 'react';
import DashboardSummary from '../DashboardSummaryNew';
import TerminationReasonsTable from './TerminationReasonsTable';
import DonutCharts from './DonutCharts';
import DashboardTable from '../DashboardTable';
import * as Constants from '../../../requests/URLConstants';
import callPostApi from "../../../requests/PostRequests";
import moment from 'moment';
import DashboardStackedBarChart from '../DashboardStackedBarChart';
import DashboardLineChart from '../DashboardLineChart';
import "@carbon/charts/styles.css";
import * as DashboardUtils from '../DashboardUtils.js';
import * as TableData from "./tableHeaders";
//import * as MockData from "./MockData.js";
import TableToolbarDownload from "../../../common/TableToolbarDownload";
import * as config from "../../../config/Constants";
import * as DashboardConstants from '.././DashboardConstants';
import * as workspaces from '../../../config/WorkspaceConstants'

require('moment-timezone');
require("./_execution-performance.scss");

const ExecutionPerformance = (props) => {

  const [terminationSummary, setTerminationSummary] = useState([]);
  const [terminationSummaryLoading, setTerminationSummaryLoading] = useState(false);
  const [weeklyHistoricalTableData, setWeeklyHistoricalTableData] = useState([]);
  const [weeklyHistoricalTableLoading, setWeeklyHistoricalTableLoading] = useState(false);
  const [terminationRateTrendLoading, setTerminationRateTrendLoading] = useState(false);
  const [terminationRateTrendData, setTerminationRateTrendData] = useState([]);
  const [historicalActivityLoading, setHistoricalActivityLoading] = useState(false);
  const [historicalActivityData, setHistoricalActivityData] = useState([]);
  const [RepeatedTerminationTableLoading, setRepeatedTerminationTableLoading] = useState(false);
  const [RepeatedTerminationBots, setRepeatedTerminationBots] = useState([]);

  let user = JSON.parse(localStorage.getItem('user'));
  const historicalActivityHeaders = [
    {
      key: 'weekly',
      header: DashboardConstants.Weekly
    },
    {
      key: 'executions',
      header: DashboardConstants.Executions
    },
    {
      key: 'exceptions',
      header: DashboardConstants.Exceptions
    },
    {
      key: 'terminations',
      header: DashboardConstants.TerminationsPercentage
    }
  ];

  const lineGraphHeaders = [{ key: 'group', header: 'Group' }, { key: 'date', header: 'Date' },
  { key: 'value', header: 'Value' }];

  useEffect(() => {
    getTerminationRate(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    getTerminationRateTrend(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    getHistoricalActivity(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    getWeeklyExecutionPerformance(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    if (config.URL.includes(config.unilever)) {
        getRepeatedTerminationBots(props.timeFilterSelections, props.filterSelectionsAutomation, props.filterSelectionsSAP, props.workspace);
    }
  }, [props.preferencesChanged]);

  const prepareTerminationRateTrendData = (response) => {
    let data = [];
    let obj = {};
    if (response) {
      let buckets = response.aggregations["4"].buckets;
      for (let i = 0; i < buckets.length; i++) {
        for (let j = 0; j < buckets[i]["5"].buckets.length; j++) {
          obj = {
            group: buckets[i]["5"].buckets[j].key,
            date: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
            value: (buckets[i]["5"].buckets[j]["3"].value).toFixed(2)
          }
          data.push(obj);
        }
      }
    }
    return data;
  };

  const getPayload = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {

    let calenderInterval = DashboardUtils.getCalenderInterval(timeFilterSelections);
    let timeZone = moment.tz.guess();
    let technology;
    let franchise;
    let client;
    let bodyJSON;

    if (workspace === workspaces.automation_ops) {
      technology = dashboardFilterSelectionsAutomation.technology;
      franchise = dashboardFilterSelectionsAutomation.franchise;
      client = dashboardFilterSelectionsAutomation.client;
      bodyJSON = {
        "filters": {
          "time": {
            "startDateTime": timeFilterSelections.startDateTime,
            "endDateTime": timeFilterSelections.endDateTime
          },
          "franchises": franchise,
          "clients": client,
          "technologies": technology,
          "deployment_models": dashboardFilterSelectionsAutomation.deployment_model,
          "geos": dashboardFilterSelectionsAutomation.geo,
          "automata_state": dashboardFilterSelectionsAutomation.automata_state,
          "business_competencies": dashboardFilterSelectionsAutomation.competency,
          "buisness_component": dashboardFilterSelectionsAutomation.buisness_component,
          "automata_priority": dashboardFilterSelectionsAutomation.priority,
          "automata_name": dashboardFilterSelectionsAutomation.automata_activity_name,
          "resource": dashboardFilterSelectionsAutomation.resource,
          "bot_id": dashboardFilterSelectionsAutomation.bot_id,
          "status": dashboardFilterSelectionsAutomation.status,
          "process_name": dashboardFilterSelectionsAutomation.process_name
        },
        "interval": {
          "calender_Interval": calenderInterval,
          "time_zone": timeZone
        },
        "workspace": workspace
      };
    }    
    return bodyJSON;
  };

  const getTerminationRateTrend = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
      setTerminationRateTrendLoading(true);
      let formattedData = [];
      let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
      callPostApi(Constants.GETTERMINATIONRATETREND, {
        'Content-Type': 'application/json'
      }, bodyJSON)
        .then(resp => {
          formattedData = prepareTerminationRateTrendData(resp);
          setTerminationRateTrendData(formattedData);
          setTerminationRateTrendLoading(false);
        }).catch((error) => {
          setTerminationRateTrendLoading(false);
          console.error('Error:', error);
        });

    }
  }

  const prepareHistoricalActivityData = (response) => {
    if (response) {
      let data = [];
      let obj = {};
      let buckets = response.aggregations["2"].buckets;
      for (let i = 0; i < buckets.length; i++) {
        for (let j = 0; j < buckets[i]["3"].buckets.length; j++) {
          obj = {
            group: buckets[i]["3"].buckets[j].key,
            key: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
            value: parseInt(buckets[i]["3"].buckets[j].doc_count)
          }
          data.push(obj);
        }
      }
      return data;
    }
  };

  const getHistoricalActivity = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
      setHistoricalActivityLoading(true);
      let formattedData = [];
      let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
      callPostApi(Constants.GETHISTORICALACTIVITY, {
        'Content-Type': 'application/json'
      }, bodyJSON)
        .then(resp => {
          formattedData = prepareHistoricalActivityData(resp);
          setHistoricalActivityData(formattedData);
          setHistoricalActivityLoading(false);
        }).catch((error) => {
          setHistoricalActivityLoading(false);
          console.error('Error:', error);
        });

    }
  }

  const prepareWeeklyHistoricalTableData = (response) => {
    let data = [];
    if (response) {
      let buckets = response.aggregations["4"].buckets;
      for (let i = 0; i < buckets.length; i++) {
        data[i] = {
          id: i + 1,
          weekly: buckets[i].key_as_string.substr(0, buckets[i].key_as_string.indexOf(' ')),
          executions: buckets[i].doc_count,
          exceptions: buckets[i].exception.value,
          terminations: (buckets[i].termination.value).toFixed(2)
        }
      }
    }
    return data;
  };

  const getWeeklyExecutionPerformance = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
      setWeeklyHistoricalTableLoading(true);
      let formattedData = [];
      let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
      callPostApi(Constants.GETWEEKLYEXECUTIONPERFORMANCE, {
        'Content-Type': 'application/json'
      }, bodyJSON)
        .then(resp => {
          formattedData = prepareWeeklyHistoricalTableData(resp);
          setWeeklyHistoricalTableLoading(false);
          setWeeklyHistoricalTableData(formattedData);
        }).catch((error) => {
          setWeeklyHistoricalTableLoading(false);
          console.error('Error:', error);
        });

    }
  }


  const prepareTerminationSummaryResponse = (data) => {
    let summary = [];
    let terminationRatePer = 0;
    if (data.aggregations.terminations_rate.value) {
      terminationRatePer = (data.aggregations.terminations_rate.value).toFixed(2)
    }
    if (data) {
      summary = [
        {
          title: DashboardConstants.Executions,
          value: data.aggregations.executions.value
        },
        {
          title: DashboardConstants.Terminations,
          value: data.aggregations.terminations.value
        },
        {
          title: DashboardConstants.TerminationRate,
          value: terminationRatePer
        }
      ]
    }
    return summary;
  }

  const getTerminationRate = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
      let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
      let formattedData = [];
      setTerminationSummaryLoading(true);
      callPostApi(Constants.GETTERMINATIONRATE, {
        'Content-Type': 'application/json'
      }, bodyJSON)
        .then(resp => {
          formattedData = prepareTerminationSummaryResponse(resp);
          setTerminationSummary(formattedData);
          setTerminationSummaryLoading(false);
        }).catch((error) => {
          console.error('Error:', error);
          setTerminationSummaryLoading(false);
        });

    }

  }

    const prepareRepeatedTerminationBots = (response) => {
        let tableData = [];
        let tableObj = {};
        if (response) {
            let buckets = response.aggregations.repeated_termination_bots.buckets;
            for (let i = 0; i < buckets.length; i++) {
                let automataNamebucket = buckets[i].automata_name.buckets
                for (let j = 0; j < automataNamebucket.length; j++) {
                    let leadPlatformbucket = automataNamebucket[j].lead_platform.buckets
                    for (let k = 0; k < leadPlatformbucket.length; k++) {
                        let subAreabucket = leadPlatformbucket[k].sub_area.buckets
                        for (let l = 0; l < subAreabucket.length; l++) {
                            let geoNamebucket = subAreabucket[l].geo_name.buckets
                            for (let m = 0; m < geoNamebucket.length; m++) {
                                let criticalitybucket = geoNamebucket[m].criticality.buckets
                                for (let n = 0; n < criticalitybucket.length; n++) {
                                    let requestedBybucket = criticalitybucket[n].requested_by.buckets
                                    for (let o = 0; o < requestedBybucket.length; o++) {
                                        let deiveryModelBucket = requestedBybucket[o].delivery_model.buckets
                                        for (let p = 0; p < deiveryModelBucket.length; p++) {
                                            let repeatedTerminationsbucket = deiveryModelBucket[p].repeated_terminations.buckets
                                            for (let q = 0; q < repeatedTerminationsbucket.length; q++) {
                                                let scheduleFrequencybucket = repeatedTerminationsbucket[q].schedule_frequency.buckets
                                                for (let r = 0; r < scheduleFrequencybucket.length; r++) {
                                                    let lastExecutionbucket = scheduleFrequencybucket[r].last_execution_start_time
                                                    tableObj = {
                                                        id: ((i + 1).toString()),
                                                        'automataName': automataNamebucket[j].key,
                                                        'leadPlatform': leadPlatformbucket[k].key,
                                                        'subArea': subAreabucket[l].key,
                                                        'geoName': geoNamebucket[m].key,
                                                        'criticality': criticalitybucket[n].key,
                                                        'requestedBy': requestedBybucket[o].key,
                                                        'deliveryModel': deiveryModelBucket[p].key,
                                                        'repeatedTerminations': repeatedTerminationsbucket[q].key,
                                                        'scheduleFrequency': scheduleFrequencybucket[r].key,
                                                        'lastExecution': lastExecutionbucket.value_as_string
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                tableData = tableData.concat(tableObj);
            }
        }
        //console.log(tableData)
        return tableData;
    };

    const getRepeatedTerminationBots = (timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace) => {
        if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP)) {
            let bodyJSON = getPayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, workspace);
            let formattedData = [];
            setRepeatedTerminationTableLoading(true);
            callPostApi(Constants.GETREPEATEDTERMINATIONBOTS, {
                'Content-Type': 'application/json'
            }, bodyJSON)
                .then(resp => {
                    formattedData = prepareRepeatedTerminationBots(resp);
                    setRepeatedTerminationTableLoading(false);
                    setRepeatedTerminationBots(formattedData);
                }).catch((error) => {
                    setRepeatedTerminationTableLoading(false);
                });
        }
    }
  return (
    <div className="top-margin dashboard execution-performance">
      {/* <HeaderPanel updateState={updateState} userPrefs={userPrefs} dashboardType={"Execution"}/> */}
      <div className="dashboard-detail-container col-lg-12 no-gutters">
        <div className="dashboard-roleContainer col-lg-12">
            <DashboardSummary title={DashboardConstants.ExecutionPerformanceSummary} loading={terminationSummaryLoading} summary={terminationSummary} />
        </div>
    <div className="dashboard-charts-container">
          <div className="report-title">
          <div>{DashboardConstants.DetailedView}</div>
          </div>
          <div className="termination-graph-container">
            <DashboardLineChart
              lineGraphData={terminationRateTrendData}
              loading={terminationRateTrendLoading}
              title={DashboardConstants.TerminationRateTrend}
              graphTitle={DashboardConstants.TerminationRatepercent}
              isPercentage={true}
            />
          </div>
          <section className="execution-graphs">
            <DonutCharts preferencesChanged={props.preferencesChanged} timeFilterSelections={props.timeFilterSelections} filterSelectionsAutomation={props.filterSelectionsAutomation} filterSelectionsSAP={props.filterSelectionsSAP} workspace={props.workspace} />
            <div className="bar-chart">
              <DashboardStackedBarChart stackedBarChartData={historicalActivityData} title={DashboardConstants.HistoricalActivityMetrics}loading={historicalActivityLoading} />
              <div className="historical-table bold-border-table">
                <DashboardTable rows={weeklyHistoricalTableData} headers={historicalActivityHeaders} showPagination={true}
                  loading={weeklyHistoricalTableLoading} isSortingAllowed={true} />
              </div>
            </div>
          </section>
          <TerminationReasonsTable preferencesChanged={props.preferencesChanged} timeFilterSelections={props.timeFilterSelections} filterSelectionsAutomation={props.filterSelectionsAutomation} filterSelectionsSAP={props.filterSelectionsSAP} workspace={props.workspace} />
                  <div>{config.URL.includes(config.unilever) ? <section className="border-bottom">
                      <div className="graph-title carbon-display-Regular-20">
                      {DashboardConstants.RepeatedTerminationBots}
                          <div className="download-button">
                              <TableToolbarDownload
                                  iconDescription={DashboardConstants.Export} rows={RepeatedTerminationBots} headers={TableData.RepeatedTerminationBotsHeaders}
                                  title={DashboardConstants.RepeatedTerminationBots} filename={DashboardConstants.RepeatedTerminationBots} label={DashboardConstants.Download}
                              />
                          </div>
                      </div>
                      <div className="bold-border-table">
                          <DashboardTable loading={RepeatedTerminationTableLoading} rows={RepeatedTerminationBots} headers={TableData.RepeatedTerminationBotsHeaders} showPagination={true} isSortingAllowed={true} />
                      </div>
                  </section> : ""}
                  </div>
        </div>
      </div>
    </div>
  );
};

export default ExecutionPerformance;
